import { render, staticRenderFns } from "./PostPackagesDatatable.vue?vue&type=template&id=61f65630&scoped=true"
import script from "./PostPackagesDatatable.vue?vue&type=script&lang=js"
export * from "./PostPackagesDatatable.vue?vue&type=script&lang=js"
import style0 from "./PostPackagesDatatable.vue?vue&type=style&index=0&id=61f65630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f65630",
  null
  
)

export default component.exports